import { InteractionType } from '@azure/msal-browser'
import { MsalAuthenticationTemplate } from '@azure/msal-react'
import { loginRequest } from '../services/msalConfig'

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
    >
      {children}
    </MsalAuthenticationTemplate>
  )
}

export default ProtectedRoute
